module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"pt":{"user_menu":{"process":"Processos","my_account":"Minha conta","notifications":"Notificações","messages":"Mensagens","switch_back":"Alterar usuário","logout":"Sair"}},"en":{"user_menu":{"process":"Process","my_account":"My account","notifications":"Notifications","messages":"Messages","switch_back":"Change user","logout":"Logout"}}}')
  delete Component.options._Ctor
}
